import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { TemplateUtenteProfilo } from '../../../models/profili-utente/template-utente-profilo';
import { UtenteProfilo } from '../../../models/profili-utente/utente-profilo';
import { TemplateUtenteUpdateComponent } from './template-utente-update.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [template-utente-mod-update]',
  templateUrl: 'template-utente-mod-update.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class TemplateUtenteModUpdateComponent {
  @Output() onReturn: EventEmitter<TemplateUtenteProfilo> = new EventEmitter<TemplateUtenteProfilo>();
  @ViewChild('formUpdateTemplateUtente') modaleTemplateUtente: TemplateUtenteUpdateComponent;

  inizializza(urlUpdateTemplateUtente: string, urlGetTemplates: string, urlGetTemplate: string, utente: UtenteProfilo, templateUtente: TemplateUtenteProfilo) {
    this.modaleTemplateUtente.inizializza(urlUpdateTemplateUtente, urlGetTemplates, urlGetTemplate, utente, templateUtente);
    openModal('modalmodupdatetemplateutente');
  }

  createForm() {
    this.modaleTemplateUtente.createForm();
  }

  manageModal(templateUtente: TemplateUtenteProfilo) {
      closeModal('modalmodupdatetemplateutente');
      this.onReturn.emit(templateUtente);
  }
}
